import { useAuthState } from './hooks/useAuthState'
import LoginPage from '../pages/Login'

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const { isSignedIn, isLoading } = useAuthState()
  if (isLoading) {
    return <></>
  }
  return isSignedIn ? children : <LoginPage />
}

export default RequireAuth
